<template>
  <div class="main-banner-container">
    <div class="main-banner">
      <!-- <img src="/images/banner-principal.png" alt=""> -->
      <div class="container-fluid h-100">
        <div class="principal-content-main-banner h-100 container">
          <div class="row align-items-center pb-md-4 justify-content-center main-banner-inner-container">
            <!-- <div class="col-md-7 position-static">
              <div class="row plan-boxes-row">
                <div class="col-md-6">
                  <div
                    class="plan-box"
                    data-aos="fade-in"
                    data-aos-duration="1000"
                  >
                    <div>
                      <span>PROGRAMA PRUEBA DE TRANSICIÓN</span>
                      <h3>PREU PDVx</h3>
                      <p>
                        Prepara la prueba de transición con clases 100% en
                        Streaming con todos los recursos del Preu PDV para ti.
                      </p>
                      <h6 style="font-size:14px;font-weight:bold;">
                        Clases comienzan en junio
                      </h6>
                    </div>

                    <a
                      class="btn-pdv-primary"
                      href="#"
                      v-on:click="
                        goToStudentForm(
                          highSchoolAcademy,
                          'Tradicional4MedioInscription',
                          true
                        )
                      "
                      >MATRICÚLATE AHORA</a
                    >
                    <p class="more-info-link-container">
                    </p>
                  </div>
                </div>
                <div class="col-md-6" />
                <div class="col-md-6">
                  <div
                    class="plan-box"
                    data-aos="fade-in"
                    data-aos-duration="1000"
                  >
                    <div>
                      <span>PROGRAMA PRUEBA DE TRANSICIÓN</span>
                      <h3>TRADICIONAL 4° MEDIO</h3>
                      <p>
                        Si estás cursando 4º medio, prepara la prueba de
                        transición con nosotros y alcanza tu meta
                      </p>
                      <h6 style="font-size:14px;font-weight:bold;">
                        Clases ya iniciadas
                      </h6>
                    </div>

                    <a
                      class="btn-pdv-primary"
                      href="#"
                      v-on:click="
                        goToStudentForm(
                          highSchoolAcademy,
                          'Tradicional4MedioInscription'
                        )
                      "
                      >MATRICÚLATE AHORA</a
                    >
                    <p class="more-info-link-container">
                      +
                      <a
                        href="https://www.preupdv.cl/programas/tradicional-4-medio/"
                        target="_blank"
                        >MÁS SOBRE ESTE PROGRAMA</a
                      >
                    </p>
                  </div>
                </div>
                <div class="col-md-6">
                  <div
                    class="plan-box"
                    data-aos="fade-in"
                    data-aos-duration="1000"
                  >
                    <div>
                      <span>PROGRAMA PRUEBA DE TRANSICIÓN</span>
                      <h3>ACADEMIA EGRESADOS</h3>
                      <p>
                        Si terminaste 4º medio o ya rendiste la prueba de
                        transición, mejora tus puntajes y entra a la carrera que
                        quieras
                      </p>
                      <h6 style="font-size:14px;font-weight:bold;">
                        Clases ya iniciadas
                      </h6>
                    </div>

                    <a
                      class="btn-pdv-primary"
                      href="#"
                      v-on:click="
                        goToStudentForm(
                          bachelorsAcademy,
                          'AcademiaEgresadosInscription'
                        )
                      "
                      >MATRICÚLATE AHORA</a
                    >
                    <p class="more-info-link-container">
                      +
                      <a
                        href="https://www.preupdv.cl/programas/academia-egresados/"
                        target="_blank"
                        >MÁS SOBRE ESTE PROGRAMA</a
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div> -->
            <div class="col-md-12 col-12 no-padding">
              <div class="text-content-main-banner">
                <!-- <div class="line-title-cont d-none d-md-block">
                  <span class="line-title">SÓLO INSCRIBIÉNDOTE ONLINE</span>
                </div> -->
                <div class="mb-2">
                  <p class="fs-md-30 upper-title">Admisión 2025</p>
                </div>
                <div class="separator"></div>
                <div class="mb-2">
                  <p class="fs-md-20 body-text-init">Bienvenido a nuestro canal de venta online</p>
                  <p class="fs-md-20 body-text">Inicia la búsqueda de tu programa perfecto con un: </p>
                </div>
                <div class="percentage d-flex flex-column flex-md-row align-items-center justify-content-start">
                  <div>
                    <p class="discount-number">{{ discount }}%</p>
                    <p class="discount">DESCUENTO</p>
                  </div>
                </div>
                <div class="pdv-button-container">
                  <a class="btn-pdv-primary-home" href="#" v-on:click.prevent="goToRecomendedCourses()">
                    Cotiza y matricúlate acá
                  </a>
                </div>
                <!-- <span
                  class="d-none d-md-inline-block"
                  style="font-size: 23.6px;width:100%;text-align:center;"
                  >¡CON EL PREU PDV CONSIGUES MÁS!</span
                > -->
              </div>
            </div>
          </div>
          <!--    <ModalInfo/> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      enabledPrograms: [],
      highSchoolAcademy: null,
      bachelorsAcademy: null,
      pdvX: null,
      discount: null
    };
  },
  methods: {
    goToRecomendedCourses() {
      this.$router.push({ name: 'Re-Step1' })
    },
    loadEnabledPrograms() {
      this.Axios.get('/programs/enabled').then((response) => {
        this.enabledPrograms = response.data;
        this.highSchoolAcademy = response.data[0];
        this.bachelorsAcademy = response.data[1];
        this.pdvX = response.data[2];
      });
    },
    configureSelectedProgram(program, isPdvX) {
      this.$store.dispatch('addSelectedProgramInfo', { ...program, isPdvX });
    },
    goToStudentForm(program, formPageName, isPdvX) {
      // this.$router.push({ name: 'Step1' });
      this.$store.dispatch('cleanLocalStorage');
      this.configureSelectedProgram(program, isPdvX);
      this.$router.push({ name: formPageName });
    }
  },

  mounted() {
    this.Axios.get('/dashadmin/infogeneral').then((response) => {
      this.discount = response.data[0].discount;

    });
    setInterval(this.discountSeconds, 1000);

  }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.main-banner-container {
  @media screen and (max-width: 430px) {
    padding-top: 76px;
  }
}

.main-banner {
  // padding-top: 120px;
  position: relative;
  height: 700px;
  background-image: url('/images/banner-home-pdv.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  @include media-breakpoint-down(sm) {
    background-image: url('/images/banner-mobile.png');
    background-size: cover;
    height: 612px;
    // padding-top: 50px;
    margin-bottom: 0;
    margin-top: 0;

    .percentage {
      margin-bottom: 19px;
    }
  }

  .logo {
    padding: 10px 34px;
  }

  .principal-content-main-banner {
    position: relative;
    display: flex;
    align-items: center;

    @include media-breakpoint-down(md) {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      padding-bottom: 27px;
    }
  }
}

.plan-boxes-row .col-md-6:first-child {
  margin-bottom: 20px;
}

.plan-boxes-row {
  @include media-breakpoint-down(md) {
    position: absolute;
    width: 100vw;
    top: 280px;
    left: 0;
    background: #000;

    .col-md-6:first-child {
      margin-bottom: 0;
    }
  }
}

/*
      .main-banner:before{
        content: '';
        width: 55%;
        height: 120px;
        position: absolute;
        left: 0;
        bottom:-90px;
        background: #fff;
        transform: skewY(4deg);
        z-index: 10;
    }

    .main-banner:after {
        content: '';
        width: 55%;
        height: 120px;
        position: absolute;
        right: 0;
        bottom: -90px;
        background: #fff;
        transform: skewY(-4deg);
        z-index: 10;
    }
    */

.text-content-main-banner {
  @include media-breakpoint-down(sm) {
    margin-top: 30px;
    padding: 0;
  }

  p {
    color: #fff;
    text-shadow: 2px 3px 12px rgba(0, 0, 0, 0.3);
    margin-bottom: 0;

    // @include font-extra-bold-regular;
    &.upper-title {
      letter-spacing: 0;
      font-weight: bold;
      line-height: 36px;
      @include Gotham-C1head();

      @media screen and (max-width: 430px) {
        @include Gotham-C1head();
        font-size: 30px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 36px;
        margin-bottom: 20px !important;
        margin-left: 10px;
      }
    }

    &.body-text {
      @include Gotham-Bold();

      @media screen and (max-width: 430px) {
        font-size: 19px;
        font-weight: bold;
        letter-spacing: -0.23px;
        line-height: 23px;
        text-align: center;
      }
    }

    &.body-text-init {
      @include Gotham-Bold();
      margin-bottom: 15px;
      font-size: 26px;

      @media screen and (max-width: 430px) {
        font-size: 24px;
        font-weight: bold;
        letter-spacing: -0.23px;
        line-height: 23px;
        text-align: center;
        margin-bottom: 15px;
      }
    }

    &.discount-number {
      font-size: 81px;
      letter-spacing: -1.1px;
      line-height: 87px;
      @include Gotham-Ultra();
    }

    &.discount {
      font-size: 21px;
      letter-spacing: -0.37px;
      line-height: 30px;
      @include Gotham-Black();
    }

    &.enroll {
      font-size: 41px;
      @include Gotham-Black();
      @media screen and (max-width: 430px) {
        font-size: 35px;
        letter-spacing: -0.54px;
        line-height: 43px;
      }

      letter-spacing: -0.7px;
    }

    &.free {
      @include Gotham-Black();
      letter-spacing: -0.7px;
      font-size: 41px;

      @media screen and (max-width: 430px) {
        margin-top: 18px;
        font-size: 45px !important;
        letter-spacing: -0.54px;
        line-height: 43px !important;
      }
    }
  }

  span {
    color: $yellow;
    @include font-extra-bold-regular;

    &.plus-icon {
      @include media-breakpoint-down(sm) {
        font-size: 60px;
        letter-spacing: -0.72px;
        line-height: 58px;
        // margin: 0px -8px;
        // position: absolute;
        // left: 0;
      }
    }
  }
}

.line-title-cont {
  text-align: center;
  position: relative;
  margin-bottom: 20px;

  @include media-breakpoint-down(sm) {
    position: absolute;
    top: 0;
    width: 100%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
  }

  .line-title {
    color: #fff;
    display: inline-block;
    letter-spacing: 4px;
    font-size: 16px;
    @include font-light-regular;

    &:before,
    &:after {
      content: '';
      position: absolute;
      width: 70px;
      height: 1px;
      background: #fff;
      top: 0.8em;
    }

    &:before {
      left: 10px;
    }

    &:after {
      right: 15px;
    }

    @include media-breakpoint-down(sm) {
      font-size: 11.18px;
      line-height: 14px;

      &:before {
        display: none;
      }

      &:after {
        display: none;
      }
    }
  }
}

.float-box-main-banner {
  margin-top: -175px;

  @include media-breakpoint-down(sm) {
    margin-top: -80px;
  }
}

.plan-box {
  background: #ffffff;
  border-radius: 20px;
  padding: 10px 30px;

  h6 {
    font-family: 'montserrat_extraboldregular', Arial, bold;
  }

  @include media-breakpoint-down(md) {
    margin-bottom: 20px;
  }

  span {
    display: block;
    background: $yellow;
    width: 80%;

    @include media-breakpoint-down(sm) {
      width: 100%;
    }

    font-size: 12px;
    line-height: 18px;
    @include font-light-regular();
  }

  h3 {
    font-size: 20px;
    line-height: 22px;
    margin-top: 10px;
    margin-bottom: 5px;
    color: #000;
    @include font-bold();
  }

  p {
    font-size: 14px;
    line-height: 18px;
    color: #000;
    min-height: calc(18px * 3);
  }

  a {
    box-shadow: none;
    border-radius: 12px;
  }

  .more-info-link-container {
    margin-top: 10px;
    margin-bottom: 0;
    min-height: auto;

    color: #000;

    a {
      color: #000;
    }
  }
}

.separator {
  height: 5px;
  width: 78px;
  background-color: #FFD100;
  margin: 0 0 35px 0;

  @media screen and (max-width: 430px) {
    margin: 0 0 33.7px 0;
    margin-left: 10px;
  }
}

.pdv-button-container {
  margin-top: 3rem;

  @include media-breakpoint-down(sm) {
    margin-top: 0;
  }
}

.btn-pdv-primary-home {
  background: $yellow;
  color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
  @include alternative-medium-regular();
  font-size: 19px;
  font-weight: 500;
  line-height: 22px;
  padding: 17.85px 25px 17.85px 24px;
  text-align: center;
  letter-spacing: -0.24px;
  width: 270px;
  height: 62px;
  border-radius: 4px;
  // box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.18);
  box-shadow: 0 2px 8px 0 rgba(7, 18, 37, 0);
  transition: all .3s ease;
  position: relative;

  &:hover {
    color: #000;
    // background: #F8E71C;
  }

  &:active {
    background: #B39334;
  }

  -webkit-appearance: unset;

  @include media-breakpoint-down(md) {
    width: 100%;
    height: 62px;
    text-align: center;
  }

  @media screen and (max-width: 360px) {
    max-width: 344px;
  }
}

.main-banner-inner-container {
  @media screen and (max-width: 430px) {
    padding: 0;
    padding-bottom: 59px;
    // margin-bottom: 59px;
  }
}

.no-padding {
  @media screen and (max-width: 430px) {
    padding: 0;
  }
}
</style>
